const NETWORK_ERROR_PATTERNS = [
  'network request failed',
  'network error',
  'failed to fetch',
  'load failed',
  'the internet connection appears to be offline',
  'a data connection is not currently allowed',
  'the request timed out',
  'could not connect to the server',
  'no internet',
];

export function isNetworkError(error: unknown): boolean {
  if (!error) return false;
  const message =
    typeof error === 'string'
      ? error
      : (error as any)?.message ?? (error as any)?.error_description ?? '';
  const lower = message.toLowerCase();
  return NETWORK_ERROR_PATTERNS.some((p) => lower.includes(p));
}

export const NETWORK_ERROR_MESSAGE =
  'No internet connection. Please check your network and try again.';
